export default "__VITE_ASSET__Cq6wd15l__"